var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.375,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#662AB2",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_432_499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 32.375H25C30 32.375 32 30.375 32 25.375V19.375C32 14.375 30 12.375 25 12.375H19C14 12.375 12 14.375 12 19.375V25.375C12 30.375 14 32.375 19 32.375Z",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 20.125C26.3284 20.125 27 19.4534 27 18.625C27 17.7966 26.3284 17.125 25.5 17.125C24.6716 17.125 24 17.7966 24 18.625C24 19.4534 24.6716 20.125 25.5 20.125Z",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.125C19.3284 20.125 20 19.4534 20 18.625C20 17.7966 19.3284 17.125 18.5 17.125C17.6716 17.125 17 17.7966 17 18.625C17 19.4534 17.6716 20.125 18.5 20.125Z",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 23.675H25.6C26.1 23.675 26.5 24.075 26.5 24.575C26.5 27.065 24.49 29.075 22 29.075C19.51 29.075 17.5 27.065 17.5 24.575C17.5 24.075 17.9 23.675 18.4 23.675Z",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_432_499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.d2f5badf77b430e94b1923aff5d495ef.svg";
export { ForwardRef as ReactComponent };